/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabDepartment from './lab-department';
import LabDepartmentDetail from './lab-department-detail';
import LabDepartmentUpdate from './lab-department-update';
import LabDepartmentDeleteDialog from './lab-department-delete-dialog';

const LabDepartmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabDepartment />} />
    <Route path="new" element={<LabDepartmentUpdate />} />
    <Route path=":id">
      <Route index element={<LabDepartmentDetail />} />
      <Route path="edit" element={<LabDepartmentUpdate />} />
      <Route path="delete" element={<LabDepartmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabDepartmentRoutes;
